import googleAnalyticsClientIdInterceptor from './googleAnalyticsClientIdInterceptor';

export const addGoogleAnalyticsClientIdInterceptor = (config, restClientInstance) => {
	if (!config.externalRequest) {
		restClientInstance._axios.interceptors.request.use(googleAnalyticsClientIdInterceptor);
	}
};
